// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1522":"5df8759a50e9527e","7734":"cc6f59b46b9d8e73"}[chunkId] + ".js";
};